import { resolveApiOrigin } from './api-origin';
import { APP_VERSION } from '../version';
import { environmentVariables } from './environment-variables';

/**
 * Staging Environment Configuration
 * Resolves API origin from the current browser hostname.
 */
const apiOrigin = resolveApiOrigin();

export const environment = {
    production: false,
    identityApiUrl: apiOrigin,
    rbiApiUrl: apiOrigin,
    merchantApiUrl: apiOrigin,
    nodeApiUrl: 'http://localhost:3000/api',
    sfmcApiUrl: 'https://sfmc-api.reprico.net',
    offerEngineApiUrl: `${apiOrigin}/roe`,
    offerEngineApiKey: 'abc123',
    // Approval Workflow API: mismo origen que el resto, con su propia base de rutas.
    approvalWorkflowApiUrl: `${apiOrigin}/approval-wkf`,
    // Viaja por .env como APPROVAL_WORKFLOW_API_KEY, igual que environmentId: la
    // entrega el equipo que opera el API una sola vez y por ambiente, y si se
    // versionara no habría forma de recuperarla tras una filtración.
    approvalWorkflowApiKey: environmentVariables.approvalWorkflowApiKey,
    // SBL Core: cronograma, sucursales y pedidos automáticos (grupo HsOrder).
    sblCoreApiUrl: `${apiOrigin}/sblcore`,
    sblCoreApiKey: environmentVariables.sblCoreApiKey,
    // La evaluación de pedidos vive en ROE pero se consume con su propia llave.
    orderEvaluationApiKey: environmentVariables.orderEvaluationApiKey,
    // Salesforce Marketing Cloud: la URL está arriba (`sfmcApiUrl`); la llave viaja por .env como SFMC_API_KEY.
    sfmcApiKey: environmentVariables.sfmcApiKey,
    // Vitamins (e-commerce): mismo origen que el resto, con su propia base de rutas y su propia llave.
    vitaminsApiUrl: `${apiOrigin}/vs/e-commerce`,
    vitaminsApiKey: environmentVariables.vitaminsApiKey,
    environmentId: environmentVariables.environmentId,
    appName: 'RBI Admin (Staging)',
    appVersion: APP_VERSION,
    logging: {
        level: 'info' as const,
        enableConsole: true,
    },
};

